import { useEffect } from "react";

import Paper from "@mui/material/Paper";

import { PageLayout } from "@mnemonic/mui";
import { ArgusUtils } from "@mnemonic/pure-utils";

import { transformUrlOpenApi } from "../Utils/transformUrl";
import { SwaggerHeader } from "./SwaggerHeader";
import { SwaggerUIView } from "./SwaggerUIView";
import { DEFAULT_API_STATUS, SERVICE_LIST, useUrlParams } from "./useUrlParams";

export const Swagger = () => {
  const { urlParams, updateUrlParams } = useUrlParams();
  const { module, apistatus } = urlParams;

  const transformedUrl = transformUrlOpenApi(ArgusUtils.getApiUrl(), module);

  const swaggerUrl =
    apistatus === "ALL" ? transformedUrl : `${transformedUrl}?apistatus=${apistatus || DEFAULT_API_STATUS}`;

  /* Setting SERVICE_LIST[0] as default module if it is not defined */
  /* Setting PUBLIC as default apistatus if it is not defined */
  useEffect(() => {
    if (!module) {
      updateUrlParams({ module: SERVICE_LIST[0] });
    }
    if (!apistatus) {
      updateUrlParams({ apistatus: DEFAULT_API_STATUS });
    }
  }, [module, apistatus]);

  if (!module) {
    return null;
  }

  return (
    <PageLayout PageHeaderProps={{ content: <SwaggerHeader /> }}>
      <Paper sx={{ py: 2, mb: 10, borderRadius: 3 }}>
        <SwaggerUIView swaggerUrl={swaggerUrl} />
      </Paper>
    </PageLayout>
  );
};
